import React, { ReactNode } from "react"

import * as styles from "./index.module.scss"

type Props = {
  index: number
  children: ReactNode
}

const DropdownContainer = ({ index, children }: Props) => {
  return (
    <nav
      className={styles.dropdownContainer}
      id={`dropdown-container-${index}`}
    >
      {children}
    </nav>
  )
}

export default DropdownContainer
